/* unplugin-vue-components disabled */import { render } from "./Preload.vue?vue&type=template&id=5f9ab253&scoped=true"
const script = {}

import "./Preload.vue?vue&type=style&index=0&id=5f9ab253&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.12_vue@3.5.12_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9ab253"]])

export default __exports__